var cldrData = [
{
    "main": {
        "es_ES": {
            "identity": {
                "version": {
                    "_number": "$Revision: 12418 $",
                    "_cldrVersion": "29"
                },
                "language": "es"
            },
            "dates": {
                "calendars": {
                    "gregorian": {
                        "months": {
                            "format": {
                                "abbreviated": {
                                    "1": "Ene",
                                    "2": "Feb",
                                    "3": "Mar",
                                    "4": "Abr",
                                    "5": "Mayo",
                                    "6": "Jun",
                                    "7": "Jul",
                                    "8": "Ago",
                                    "9": "Sep",
                                    "10": "Oct",
                                    "11": "Nov",
                                    "12": "Dic"
                                },
                                "narrow": {
                                    "1": "E",
                                    "2": "F",
                                    "3": "M",
                                    "4": "A",
                                    "5": "M",
                                    "6": "J",
                                    "7": "J",
                                    "8": "A",
                                    "9": "S",
                                    "10": "O",
                                    "11": "N",
                                    "12": "D"
                                },
                                "wide": {
                                    "1": "Enero",
                                    "2": "Febrero",
                                    "3": "Marzo",
                                    "4": "Abril",
                                    "5": "Mayo",
                                    "6": "Junio",
                                    "7": "Julio",
                                    "8": "Agosto",
                                    "9": "Septiembre",
                                    "10": "Octubre",
                                    "11": "Noviembre",
                                    "12": "Diciembre"
                                }
                            },
                            "stand-alone": {
                                "abbreviated": {
                                    "1": "Ene",
                                    "2": "Feb",
                                    "3": "Mar",
                                    "4": "Abr",
                                    "5": "May",
                                    "6": "Jun",
                                    "7": "Jul",
                                    "8": "Ago",
                                    "9": "Sep",
                                    "10": "Oct",
                                    "11": "Nov",
                                    "12": "Dic"
                                },
                                "narrow": {
                                    "1": "E",
                                    "2": "F",
                                    "3": "M",
                                    "4": "A",
                                    "5": "M",
                                    "6": "J",
                                    "7": "J",
                                    "8": "A",
                                    "9": "S",
                                    "10": "O",
                                    "11": "N",
                                    "12": "D"
                                },
                                "wide": {
                                    "1": "Enero",
                                    "2": "Febrero",
                                    "3": "Marzo",
                                    "4": "Abril",
                                    "5": "Mayo",
                                    "6": "Junio",
                                    "7": "Julio",
                                    "8": "Agosto",
                                    "9": "Septiembre",
                                    "10": "Octubre",
                                    "11": "Noviembre",
                                    "12": "Diciembre"
                                }
                            }
                        },
                        "days": {
                            "format": {
                                "abbreviated": {
                                    "sun": "Dom",
                                    "mon": "Lun",
                                    "tue": "Mar",
                                    "wed": "Mié ",
                                    "thu": "Jue",
                                    "fri": "Vier.",
                                    "sat": "Sáb."
                                },
                                "narrow": {
                                    "sun": "S",
                                    "mon": "M",
                                    "tue": "T",
                                    "wed": "W",
                                    "thu": "T",
                                    "fri": "F",
                                    "sat": "S"
                                },
                                "short": {
                                    "sun": "Do",
                                    "mon": "Lu",
                                    "tue": "Ma",
                                    "wed": "Mi",
                                    "thu": "Ju",
                                    "fri": "Vi",
                                    "sat": "Sá"
                                },
                                "wide": {
                                    "sun": "Domingo",
                                    "mon": "Lunes",
                                    "tue": "Martes",
                                    "wed": "Miércoles",
                                    "thu": "Jueves",
                                    "fri": "Viernes",
                                    "sat": "Sábado"
                                }
                            },
                            "stand-alone": {
                                "abbreviated": {
                                    "sun": "Dom",
                                    "mon": "Lun",
                                    "tue": "Mar",
                                    "wed": "Mié ",
                                    "thu": "Jue",
                                    "fri": "Vier.",
                                    "sat": "Sáb."
                                },
                                "narrow": {
                                    "sun": "S",
                                    "mon": "M",
                                    "tue": "T",
                                    "wed": "W",
                                    "thu": "T",
                                    "fri": "F",
                                    "sat": "S"
                                },
                                "short": {
                                    "sun": "Do",
                                    "mon": "Lu",
                                    "tue": "Ma",
                                    "wed": "Mi",
                                    "thu": "Ju",
                                    "fri": "Vi",
                                    "sat": "Sá"
                                },
                                "wide": {
                                    "sun": "Domingo",
                                    "mon": "Lunes",
                                    "tue": "Martes",
                                    "wed": "Miércoles",
                                    "thu": "Jueves",
                                    "fri": "Viernes",
                                    "sat": "Sábado"
                                }
                            }
                        },
                        "quarters": {
                            "format": {
                                "abbreviated": {
                                    "1": "T1",
                                    "2": "T2",
                                    "3": "T3",
                                    "4": "T4"
                                },
                                "narrow": {
                                    "1": "1",
                                    "2": "2",
                                    "3": "3",
                                    "4": "4"
                                },
                                "wide": {
                                    "1": "1er trimestre",
                                    "2": "2do trimestre",
                                    "3": "3er trimestre",
                                    "4": "4to trimestre"
                                }
                            },
                            "stand-alone": {
                                "abbreviated": {
                                    "1": "T1",
                                    "2": "T2",
                                    "3": "T3",
                                    "4": "T4"
                                },
                                "narrow": {
                                    "1": "1",
                                    "2": "2",
                                    "3": "3",
                                    "4": "4"
                                },
                                "wide": {
                                    "1": "1er trimestre",
                                    "2": "2do trimestre",
                                    "3": "3er trimestre",
                                    "4": "4to trimestre"
                                }
                            }
                        },
                        "dayPeriods": {
                            "format": {
                                "abbreviated": {
                                    "midnight": "medianoche",
                                    "am": "AM",
                                    "am-alt-variant": "am",
                                    "noon": "tarde",
                                    "pm": "PM",
                                    "pm-alt-variant": "pm",
                                    "morning1": "de la mañana",
                                    "afternoon1": "de la tarde",
                                    "evening1": "de la tarde",
                                    "night1": "de la noche"
                                },
                                "narrow": {
                                    "midnight": "mn",
                                    "am": "a",
                                    "am-alt-variant": "am",
                                    "noon": "n",
                                    "pm": "p",
                                    "pm-alt-variant": "pm",
                                    "morning1": "de la mañana",
                                    "afternoon1": "de la tarde",
                                    "evening1": "de la tarde",
                                    "night1": "de la noche"
                                },
                                "wide": {
                                    "midnight": "medianoche",
                                    "am": "AM",
                                    "am-alt-variant": "am",
                                    "noon": "tarde",
                                    "pm": "PM",
                                    "pm-alt-variant": "pm",
                                    "morning1": "de la mañana",
                                    "afternoon1": "de la tarde",
                                    "evening1": "de la tarde",
                                    "night1": "de la noche"
                                }
                            },
                            "stand-alone": {
                                "abbreviated": {
                                    "midnight": "medianoche",
                                    "am": "AM",
                                    "am-alt-variant": "am",
                                    "noon": "tarde",
                                    "pm": "PM",
                                    "pm-alt-variant": "pm",
                                    "morning1": "de la mañana",
                                    "afternoon1": "de la tarde",
                                    "evening1": "de la tarde",
                                    "night1": "de la noche"
                                },
                                "narrow": {
                                    "midnight": "medianoche",
                                    "am": "AM",
                                    "am-alt-variant": "am",
                                    "noon": "tarde",
                                    "pm": "PM",
                                    "pm-alt-variant": "pm",
                                    "morning1": "de la mañana",
                                    "afternoon1": "de la tarde",
                                    "evening1": "de la tarde",
                                    "night1": "de la noche"
                                },
                                "wide": {
                                    "midnight": "medianoche",
                                    "am": "AM",
                                    "am-alt-variant": "am",
                                    "noon": "tarde",
                                    "pm": "PM",
                                    "pm-alt-variant": "pm",
                                    "morning1": "mañana",
                                    "afternoon1": "tarde",
                                    "evening1": "tarde",
                                    "night1": "noche"
                                }
                            }
                        },
                        "eras": {
                            "eraNames": {
                                "0": "Antes de Cristo",
                                "0-alt-variant": "Antes de nuestra era",
                                "1": "Anno Domini",
                                "1-alt-variant": "Nuestra era"
                            },
                            "eraAbbr": {
                                "0": "a.C.",
                                "0-alt-variant": "BCE",
                                "1": "AD",
                                "1-alt-variant": "CE"
                            },
                            "eraNarrow": {
                                "0": "B",
                                "0-alt-variant": "BCE",
                                "1": "A",
                                "1-alt-variant": "CE"
                            }
                        },
                        "dateFormats": {
                            "full": "EEEE, d MMMM, y",
                            "long": "d MMMM, y",
                            "medium": "d MMM, y",
                            "short": "d/M/yy"
                        },
                        "timeFormats": {
                            "full": "h:mm:ss a zzzz",
                            "long": "h:mm:ss a z",
                            "medium": "h:mm:ss a",
                            "short": "h:mm a"
                        },
                        "dateTimeFormats": {
                            "full": "{1} 'a las' {0}",
                            "long": "{1} 'a las' {0}",
                            "medium": "{1}, {0}",
                            "short": "{1}, {0}",
                            "availableFormats": {
                                "d": "d",
                                "E": "ccc",
                                "Ed": "d E",
                                "Ehm": "E h:mm a",
                                "EHm": "E HH:mm",
                                "Ehms": "E h:mm:ss a",
                                "EHms": "E HH:mm:ss",
                                "Gy": "y G",
                                "GyMMM": "MMM y G",
                                "GyMMMd": "d MMM, y G",
                                "GyMMMEd": "E, d MMM, y G",
                                "h": "h a",
                                "H": "HH",
                                "hm": "h:mm a",
                                "Hm": "HH:mm",
                                "hms": "h:mm:ss a",
                                "Hms": "HH:mm:ss",
                                "hmsv": "h:mm:ss a v",
                                "Hmsv": "HH:mm:ss v",
                                "hmv": "h:mm a v",
                                "Hmv": "HH:mm v",
                                "M": "L",
                                "Md": "M/d",
                                "MEd": "E, M/d",
                                "MMM": "LLL",
                                "MMMd": "d MMM",
                                "MMMEd": "E, d MMM",
                                "MMMMd": "d MMMM",
                                "ms": "mm:ss",
                                "y": "a",
                                "yM": "M/y",
                                "yMd": "d/M/y",
                                "yMEd": "E, d/M/y",
                                "yMMM": "MMM y",
                                "yMMMd": "d MMM, y",
                                "yMMMEd": "E, d MMM, y",
                                "yMMMM": "MMMM y",
                                "yQQQ": "TTT y",
                                "yQQQQ": "TTTT y"
                            },
                            "appendItems": {
                                "Day": "{0} ({2}: {1})",
                                "Day-Of-Week": "{0} {1}",
                                "Era": "{0} {1}",
                                "Hour": "{0} ({2}: {1})",
                                "Minute": "{0} ({2}: {1})",
                                "Month": "{0} ({2}: {1})",
                                "Quarter": "{0} ({2}: {1})",
                                "Second": "{0} ({2}: {1})",
                                "Timezone": "{0} {1}",
                                "Week": "{0} ({2}: {1})",
                                "Year": "{0} {1}"
                            },
                            "intervalFormats": {
                                "intervalFormatFallback": "{0} – {1}",
                                "d": {
                                    "d": "d – d"
                                },
                                "h": {
                                    "a": "h a – h a",
                                    "h": "h – h a"
                                },
                                "H": {
                                    "H": "HH – HH"
                                },
                                "hm": {
                                    "a": "h:mm a – h:mm a",
                                    "h": "h:mm – h:mm a",
                                    "m": "h:mm – h:mm a"
                                },
                                "Hm": {
                                    "H": "HH:mm – HH:mm",
                                    "m": "HH:mm – HH:mm"
                                },
                                "hmv": {
                                    "a": "h:mm a – h:mm a v",
                                    "h": "h:mm – h:mm a v",
                                    "m": "h:mm – h:mm a v"
                                },
                                "Hmv": {
                                    "H": "HH:mm – HH:mm v",
                                    "m": "HH:mm – HH:mm v"
                                },
                                "hv": {
                                    "a": "h a – h a v",
                                    "h": "h – h a v"
                                },
                                "Hv": {
                                    "H": "HH – HH v"
                                },
                                "M": {
                                    "M": "M – M"
                                },
                                "Md": {
                                    "d": "d/M – d/M",
                                    "M": "d/M – d/M"
                                },
                                "MEd": {
                                    "d": "E, d/M – E, d/M",
                                    "M": "E, d/M – E, d/M"
                                },
                                "MMM": {
                                    "M": "MMM – MMM"
                                },
                                "MMMd": {
                                    "d": "MMM d – d",
                                    "M": "d MMM – d MMM"
                                },
                                "MMMEd": {
                                    "d": "E, d MMM – E, d MMM",
                                    "M": "E, d MMM – E, d MMM"
                                },
                                "y": {
                                    "y": "y – y"
                                },
                                "yM": {
                                    "M": "M/y – M/y",
                                    "y": "M/y – M/y"
                                },
                                "yMd": {
                                    "d": "d/M/y – d/M/y",
                                    "M": "d/M/y – d/M/y",
                                    "y": "d/M/y – d/M/y"
                                },
                                "yMEd": {
                                    "d": "E, d/M/y – E, d/M/y",
                                    "M": "E, d/M/y – E, d/M/y",
                                    "y": "E, d/M/y – E, d/M/y"
                                },
                                "yMMM": {
                                    "M": "MMM – MMM y",
                                    "y": "MMM y – MMM y"
                                },
                                "yMMMd": {
                                    "d": "d MMM – d, y",
                                    "M": "d MMM – d MMM, y",
                                    "y": "d MMM, y – d MMM, y"
                                },
                                "yMMMEd": {
                                    "d": "E, MMM d – E, d MMM, y",
                                    "M": "E, d MMM – E, d MMM, y",
                                    "y": "E, d MMM, y – E, d MMM, y"
                                },
                                "yMMMM": {
                                    "M": "MMMM – MMMM y",
                                    "y": "MMMM y – MMMM y"
                                }
                            }
                        }
                    }
                }
            },
            "numbers": {
                "defaultNumberingSystem": "latn",
                "otherNumberingSystems": {
                "native": "latn"
                },
                "minimumGroupingDigits": "2",
                "symbols-numberSystem-latn": {
                "decimal": ",",
                "group": ".",
                "list": ";",
                "percentSign": "%",
                "plusSign": "+",
                "minusSign": "-",
                "exponential": "E",
                "superscriptingExponent": "×",
                "perMille": "‰",
                "infinity": "∞",
                "nan": "NaN",
                "timeSeparator": ":"
                },
                "decimalFormats-numberSystem-latn": {
                "standard": "#,##0.###",
                "long": {
                    "decimalFormat": {
                    "1000-count-one": "0 mil",
                    "1000-count-other": "0 mil",
                    "10000-count-one": "00 mil",
                    "10000-count-other": "00 mil",
                    "100000-count-one": "000 mil",
                    "100000-count-other": "000 mil",
                    "1000000-count-one": "0 millón",
                    "1000000-count-other": "0 millones",
                    "10000000-count-one": "00 millones",
                    "10000000-count-other": "00 millones",
                    "100000000-count-one": "000 millones",
                    "100000000-count-other": "000 millones",
                    "1000000000-count-one": "0 mil millones",
                    "1000000000-count-other": "0 mil millones",
                    "10000000000-count-one": "00 mil millones",
                    "10000000000-count-other": "00 mil millones",
                    "100000000000-count-one": "000 mil millones",
                    "100000000000-count-other": "000 mil millones",
                    "1000000000000-count-one": "0 billón",
                    "1000000000000-count-other": "0 billones",
                    "10000000000000-count-one": "00 billones",
                    "10000000000000-count-other": "00 billones",
                    "100000000000000-count-one": "000 billones",
                    "100000000000000-count-other": "000 billones"
                    }
                },
                "short": {
                    "decimalFormat": {
                    "1000-count-one": "0 K",
                    "1000-count-other": "0 K",
                    "10000-count-one": "00 K",
                    "10000-count-other": "00 K",
                    "100000-count-one": "000 K",
                    "100000-count-other": "000 K",
                    "1000000-count-one": "0 M",
                    "1000000-count-other": "0 M",
                    "10000000-count-one": "00 M",
                    "10000000-count-other": "00 M",
                    "100000000-count-one": "000 M",
                    "100000000-count-other": "000 M",
                    "1000000000-count-one": "0000 M",
                    "1000000000-count-other": "0000 M",
                    "10000000000-count-one": "00 MRD",
                    "10000000000-count-other": "00 MRD",
                    "100000000000-count-one": "000 MRD",
                    "100000000000-count-other": "000 MRD",
                    "1000000000000-count-one": "0 B",
                    "1000000000000-count-other": "0 B",
                    "10000000000000-count-one": "00 B",
                    "10000000000000-count-other": "00 B",
                    "100000000000000-count-one": "000 B",
                    "100000000000000-count-other": "000 B"
                    }
                }
                },
                "scientificFormats-numberSystem-latn": {
                "standard": "#E0"
                },
                "percentFormats-numberSystem-latn": {
                "standard": "#,##0 %"
                },
                "currencyFormats-numberSystem-latn": {
                "currencySpacing": {
                    "beforeCurrency": {
                    "currencyMatch": "[:^S:]",
                    "surroundingMatch": "[:digit:]",
                    "insertBetween": " "
                    },
                    "afterCurrency": {
                    "currencyMatch": "[:^S:]",
                    "surroundingMatch": "[:digit:]",
                    "insertBetween": " "
                    }
                },
                "standard": "#,##0.00 ¤",
                "accounting": "#,##0.00 ¤",
                "short": {
                    "standard": {
                    "1000-count-one": "0 K ¤",
                    "1000-count-other": "0 K ¤",
                    "10000-count-one": "00 K ¤",
                    "10000-count-other": "00 K ¤",
                    "100000-count-one": "000 K ¤",
                    "100000-count-other": "000 K ¤",
                    "1000000-count-one": "0 M ¤",
                    "1000000-count-other": "0 M ¤",
                    "10000000-count-one": "00 M ¤",
                    "10000000-count-other": "00 M ¤",
                    "100000000-count-one": "000 M ¤",
                    "100000000-count-other": "000 M ¤",
                    "1000000000-count-one": "0000 M ¤",
                    "1000000000-count-other": "0000 M ¤",
                    "10000000000-count-one": "00 MRD ¤",
                    "10000000000-count-other": "00 MRD ¤",
                    "100000000000-count-one": "000 MRD ¤",
                    "100000000000-count-other": "000 MRD ¤",
                    "1000000000000-count-one": "0 B ¤",
                    "1000000000000-count-other": "0 B ¤",
                    "10000000000000-count-one": "00 B ¤",
                    "10000000000000-count-other": "00 B ¤",
                    "100000000000000-count-one": "000 B ¤",
                    "100000000000000-count-other": "000 B ¤"
                    }
                },
                "unitPattern-count-one": "{0} {1}",
                "unitPattern-count-other": "{0} {1}"
                },
                "miscPatterns-numberSystem-latn": {
                "atLeast": "Más de {0}",
                "range": "{0}-{1}"
                },
                "currencies": {
                "ADP": {
                    "displayName": "peseta andorrana",
                    "displayName-count-one": "peseta andorrana",
                    "displayName-count-other": "pesetas andorranas",
                    "symbol": "ADP"
                },
                "AED": {
                    "displayName": "dírham de los Emiratos Árabes Unidos",
                    "displayName-count-one": "dírham de los Emiratos Árabes Unidos",
                    "displayName-count-other": "dírhams de los Emiratos Árabes Unidos",
                    "symbol": "AED"
                },
                "AFA": {
                    "displayName": "afgani (1927–2002)",
                    "symbol": "AFA"
                },
                "AFN": {
                    "displayName": "afgani",
                    "displayName-count-one": "afgani",
                    "displayName-count-other": "afganis",
                    "symbol": "AFN"
                },
                "ALL": {
                    "displayName": "lek",
                    "displayName-count-one": "lek",
                    "displayName-count-other": "lekes",
                    "symbol": "ALL"
                },
                "AMD": {
                    "displayName": "dram",
                    "displayName-count-one": "dram",
                    "displayName-count-other": "drams",
                    "symbol": "AMD"
                },
                "ANG": {
                    "displayName": "florín de las Antillas Neerlandesas",
                    "displayName-count-one": "florín de las Antillas Neerlandesas",
                    "displayName-count-other": "florines de las Antillas Neerlandesas",
                    "symbol": "ANG"
                },
                "AOA": {
                    "displayName": "kuanza",
                    "displayName-count-one": "kuanza",
                    "displayName-count-other": "kuanzas",
                    "symbol": "AOA",
                    "symbol-alt-narrow": "Kz"
                },
                "AOK": {
                    "displayName": "kwanza angoleño (1977–1990)",
                    "symbol": "AOK"
                },
                "AON": {
                    "displayName": "nuevo kwanza angoleño (1990–2000)",
                    "symbol": "AON"
                },
                "AOR": {
                    "displayName": "kwanza reajustado angoleño (1995–1999)",
                    "symbol": "AOR"
                },
                "ARA": {
                    "displayName": "austral argentino",
                    "displayName-count-one": "austral argentino",
                    "displayName-count-other": "australes argentinos",
                    "symbol": "ARA"
                },
                "ARL": {
                    "displayName": "ARL",
                    "symbol": "ARL"
                },
                "ARM": {
                    "displayName": "ARM",
                    "symbol": "ARM"
                },
                "ARP": {
                    "displayName": "peso argentino (1983–1985)",
                    "displayName-count-one": "peso argentino (ARP)",
                    "displayName-count-other": "pesos argentinos (ARP)",
                    "symbol": "ARP"
                },
                "ARS": {
                    "displayName": "peso argentino",
                    "displayName-count-one": "peso argentino",
                    "displayName-count-other": "pesos argentinos",
                    "symbol": "ARS",
                    "symbol-alt-narrow": "$"
                },
                "ATS": {
                    "displayName": "chelín austriaco",
                    "displayName-count-one": "chelín austriaco",
                    "displayName-count-other": "chelines austriacos",
                    "symbol": "ATS"
                },
                "AUD": {
                    "displayName": "dólar australiano",
                    "displayName-count-one": "dólar australiano",
                    "displayName-count-other": "dólares australianos",
                    "symbol": "AUD",
                    "symbol-alt-narrow": "$"
                },
                "AWG": {
                    "displayName": "florín arubeño",
                    "displayName-count-one": "florín arubeño",
                    "displayName-count-other": "florines arubeños",
                    "symbol": "AWG"
                },
                "AZM": {
                    "displayName": "manat azerí (1993–2006)",
                    "symbol": "AZM"
                },
                "AZN": {
                    "displayName": "manat azerí",
                    "displayName-count-one": "manat azerí",
                    "displayName-count-other": "manat azeríes",
                    "symbol": "AZN"
                },
                "BAD": {
                    "displayName": "dinar bosnio",
                    "displayName-count-one": "dinar bosnio",
                    "displayName-count-other": "dinares bosnios",
                    "symbol": "BAD"
                },
                "BAM": {
                    "displayName": "marco convertible de Bosnia-Herzegovina",
                    "displayName-count-one": "marco convertible de Bosnia-Herzegovina",
                    "displayName-count-other": "marcos convertibles de Bosnia-Herzegovina",
                    "symbol": "BAM",
                    "symbol-alt-narrow": "KM"
                },
                "BAN": {
                    "displayName": "BAN",
                    "symbol": "BAN"
                },
                "BBD": {
                    "displayName": "dólar barbadense",
                    "displayName-count-one": "dólar barbadense",
                    "displayName-count-other": "dólares barbadenses",
                    "symbol": "BBD",
                    "symbol-alt-narrow": "$"
                },
                "BDT": {
                    "displayName": "taka",
                    "displayName-count-one": "taka",
                    "displayName-count-other": "takas",
                    "symbol": "BDT",
                    "symbol-alt-narrow": "৳"
                },
                "BEC": {
                    "displayName": "franco belga (convertible)",
                    "displayName-count-one": "franco belga (convertible)",
                    "displayName-count-other": "francos belgas (convertibles)",
                    "symbol": "BEC"
                },
                "BEF": {
                    "displayName": "franco belga",
                    "displayName-count-one": "franco belga",
                    "displayName-count-other": "francos belgas",
                    "symbol": "BEF"
                },
                "BEL": {
                    "displayName": "franco belga (financiero)",
                    "displayName-count-one": "franco belga (financiero)",
                    "displayName-count-other": "francos belgas (financieros)",
                    "symbol": "BEL"
                },
                "BGL": {
                    "displayName": "lev fuerte búlgaro",
                    "displayName-count-one": "lev fuerte búlgaro",
                    "displayName-count-other": "leva fuertes búlgaros",
                    "symbol": "BGL"
                },
                "BGM": {
                    "displayName": "BGM",
                    "symbol": "BGM"
                },
                "BGN": {
                    "displayName": "lev búlgaro",
                    "displayName-count-one": "lev búlgaro",
                    "displayName-count-other": "levas búlgaras",
                    "symbol": "BGN"
                },
                "BGO": {
                    "displayName": "BGO",
                    "symbol": "BGO"
                },
                "BHD": {
                    "displayName": "dinar bahreiní",
                    "displayName-count-one": "dinar bahreiní",
                    "displayName-count-other": "dinares bahreiníes",
                    "symbol": "BHD"
                },
                "BIF": {
                    "displayName": "franco burundés",
                    "displayName-count-one": "franco burundés",
                    "displayName-count-other": "francos burundeses",
                    "symbol": "BIF"
                },
                "BMD": {
                    "displayName": "dólar de Bermudas",
                    "displayName-count-one": "dólar de Bermudas",
                    "displayName-count-other": "dólares de Bermudas",
                    "symbol": "BMD",
                    "symbol-alt-narrow": "$"
                },
                "BND": {
                    "displayName": "dólar bruneano",
                    "displayName-count-one": "dólar bruneano",
                    "displayName-count-other": "dólares bruneanos",
                    "symbol": "BND",
                    "symbol-alt-narrow": "$"
                },
                "BOB": {
                    "displayName": "boliviano",
                    "displayName-count-one": "boliviano",
                    "displayName-count-other": "bolivianos",
                    "symbol": "BOB",
                    "symbol-alt-narrow": "Bs"
                },
                "BOL": {
                    "displayName": "BOL",
                    "symbol": "BOL"
                },
                "BOP": {
                    "displayName": "peso boliviano",
                    "displayName-count-one": "peso boliviano",
                    "displayName-count-other": "pesos bolivianos",
                    "symbol": "BOP"
                },
                "BOV": {
                    "displayName": "MVDOL boliviano",
                    "displayName-count-one": "MVDOL boliviano",
                    "displayName-count-other": "MVDOL bolivianos",
                    "symbol": "BOV"
                },
                "BRB": {
                    "displayName": "nuevo cruceiro brasileño (1967–1986)",
                    "displayName-count-one": "nuevo cruzado brasileño (BRB)",
                    "displayName-count-other": "nuevos cruzados brasileños (BRB)",
                    "symbol": "BRB"
                },
                "BRC": {
                    "displayName": "cruzado brasileño",
                    "displayName-count-one": "cruzado brasileño",
                    "displayName-count-other": "cruzados brasileños",
                    "symbol": "BRC"
                },
                "BRE": {
                    "displayName": "cruceiro brasileño (1990–1993)",
                    "displayName-count-one": "cruceiro brasileño (BRE)",
                    "displayName-count-other": "cruceiros brasileños (BRE)",
                    "symbol": "BRE"
                },
                "BRL": {
                    "displayName": "real brasileño",
                    "displayName-count-one": "real brasileño",
                    "displayName-count-other": "reales brasileños",
                    "symbol": "BRL",
                    "symbol-alt-narrow": "R$"
                },
                "BRN": {
                    "displayName": "nuevo cruzado brasileño",
                    "displayName-count-one": "nuevo cruzado brasileño",
                    "displayName-count-other": "nuevos cruzados brasileños",
                    "symbol": "BRN"
                },
                "BRR": {
                    "displayName": "cruceiro brasileño",
                    "displayName-count-one": "cruceiro brasileño",
                    "displayName-count-other": "cruceiros brasileños",
                    "symbol": "BRR"
                },
                "BRZ": {
                    "displayName": "BRZ",
                    "symbol": "BRZ"
                },
                "BSD": {
                    "displayName": "dólar bahameño",
                    "displayName-count-one": "dólar bahameño",
                    "displayName-count-other": "dólares bahameños",
                    "symbol": "BSD",
                    "symbol-alt-narrow": "$"
                },
                "BTN": {
                    "displayName": "gultrum",
                    "displayName-count-one": "gultrum",
                    "displayName-count-other": "gultrums",
                    "symbol": "BTN"
                },
                "BUK": {
                    "displayName": "kyat birmano",
                    "displayName-count-one": "kyat birmano",
                    "displayName-count-other": "kyat birmanos",
                    "symbol": "BUK"
                },
                "BWP": {
                    "displayName": "pula",
                    "displayName-count-one": "pula",
                    "displayName-count-other": "pulas",
                    "symbol": "BWP",
                    "symbol-alt-narrow": "P"
                },
                "BYB": {
                    "displayName": "nuevo rublo bielorruso (1994–1999)",
                    "displayName-count-one": "nuevo rublo bielorruso",
                    "displayName-count-other": "nuevos rublos bielorrusos",
                    "symbol": "BYB"
                },
                "BYR": {
                    "displayName": "rublo bielorruso",
                    "displayName-count-one": "rublo bielorruso",
                    "displayName-count-other": "rublos bielorrusos",
                    "symbol": "BYR",
                    "symbol-alt-narrow": "р."
                },
                "BZD": {
                    "displayName": "dólar beliceño",
                    "displayName-count-one": "dólar beliceño",
                    "displayName-count-other": "dólares beliceños",
                    "symbol": "BZD",
                    "symbol-alt-narrow": "$"
                },
                "CAD": {
                    "displayName": "dólar canadiense",
                    "displayName-count-one": "dólar canadiense",
                    "displayName-count-other": "dólares canadienses",
                    "symbol": "CA$",
                    "symbol-alt-narrow": "$"
                },
                "CDF": {
                    "displayName": "franco congoleño",
                    "displayName-count-one": "franco congoleño",
                    "displayName-count-other": "francos congoleños",
                    "symbol": "CDF"
                },
                "CHE": {
                    "displayName": "euro WIR",
                    "displayName-count-one": "euro WIR",
                    "displayName-count-other": "euros WIR",
                    "symbol": "CHE"
                },
                "CHF": {
                    "displayName": "franco suizo",
                    "displayName-count-one": "franco suizo",
                    "displayName-count-other": "francos suizos",
                    "symbol": "CHF"
                },
                "CHW": {
                    "displayName": "franco WIR",
                    "displayName-count-one": "franco WIR",
                    "displayName-count-other": "francos WIR",
                    "symbol": "CHW"
                },
                "CLE": {
                    "displayName": "CLE",
                    "symbol": "CLE"
                },
                "CLF": {
                    "displayName": "unidad de fomento chilena",
                    "displayName-count-one": "unidad de fomento chilena",
                    "displayName-count-other": "unidades de fomento chilenas",
                    "symbol": "CLF"
                },
                "CLP": {
                    "displayName": "peso chileno",
                    "displayName-count-one": "peso chileno",
                    "displayName-count-other": "pesos chilenos",
                    "symbol": "CLP",
                    "symbol-alt-narrow": "$"
                },
                "CNY": {
                    "displayName": "yuan",
                    "displayName-count-one": "yuan",
                    "displayName-count-other": "yuanes",
                    "symbol": "CNY",
                    "symbol-alt-narrow": "¥"
                },
                "COP": {
                    "displayName": "peso colombiano",
                    "displayName-count-one": "peso colombiano",
                    "displayName-count-other": "pesos colombianos",
                    "symbol": "COP",
                    "symbol-alt-narrow": "$"
                },
                "COU": {
                    "displayName": "unidad de valor real colombiana",
                    "displayName-count-one": "unidad de valor real",
                    "displayName-count-other": "unidades de valor reales",
                    "symbol": "COU"
                },
                "CRC": {
                    "displayName": "colón costarricense",
                    "displayName-count-one": "colón costarricense",
                    "displayName-count-other": "colones costarricenses",
                    "symbol": "CRC",
                    "symbol-alt-narrow": "₡"
                },
                "CSD": {
                    "displayName": "antiguo dinar serbio",
                    "displayName-count-one": "antiguo dinar serbio",
                    "displayName-count-other": "antiguos dinares serbios",
                    "symbol": "CSD"
                },
                "CSK": {
                    "displayName": "corona fuerte checoslovaca",
                    "displayName-count-one": "corona fuerte checoslovaca",
                    "displayName-count-other": "coronas fuertes checoslovacas",
                    "symbol": "CSK"
                },
                "CUC": {
                    "displayName": "peso cubano convertible",
                    "displayName-count-one": "peso cubano convertible",
                    "displayName-count-other": "pesos cubanos convertibles",
                    "symbol": "CUC",
                    "symbol-alt-narrow": "$"
                },
                "CUP": {
                    "displayName": "peso cubano",
                    "displayName-count-one": "peso cubano",
                    "displayName-count-other": "pesos cubanos",
                    "symbol": "CUP",
                    "symbol-alt-narrow": "$"
                },
                "CVE": {
                    "displayName": "escudo de Cabo Verde",
                    "displayName-count-one": "escudo de Cabo Verde",
                    "displayName-count-other": "escudos de Cabo Verde",
                    "symbol": "CVE"
                },
                "CYP": {
                    "displayName": "libra chipriota",
                    "displayName-count-one": "libra chipriota",
                    "displayName-count-other": "libras chipriotas",
                    "symbol": "CYP"
                },
                "CZK": {
                    "displayName": "corona checa",
                    "displayName-count-one": "corona checa",
                    "displayName-count-other": "coronas checas",
                    "symbol": "CZK",
                    "symbol-alt-narrow": "Kč"
                },
                "DDM": {
                    "displayName": "ostmark de Alemania del Este",
                    "displayName-count-one": "marco de la República Democrática Alemana",
                    "displayName-count-other": "marcos de la República Democrática Alemana",
                    "symbol": "DDM"
                },
                "DEM": {
                    "displayName": "marco alemán",
                    "displayName-count-one": "marco alemán",
                    "displayName-count-other": "marcos alemanes",
                    "symbol": "DEM"
                },
                "DJF": {
                    "displayName": "franco yibutiano",
                    "displayName-count-one": "franco yibutiano",
                    "displayName-count-other": "francos yibutianos",
                    "symbol": "DJF"
                },
                "DKK": {
                    "displayName": "corona danesa",
                    "displayName-count-one": "corona danesa",
                    "displayName-count-other": "coronas danesas",
                    "symbol": "DKK",
                    "symbol-alt-narrow": "kr"
                },
                "DOP": {
                    "displayName": "peso dominicano",
                    "displayName-count-one": "peso dominicano",
                    "displayName-count-other": "pesos dominicanos",
                    "symbol": "DOP",
                    "symbol-alt-narrow": "$"
                },
                "DZD": {
                    "displayName": "dinar argelino",
                    "displayName-count-one": "dinar argelino",
                    "displayName-count-other": "dinares argelinos",
                    "symbol": "DZD"
                },
                "ECS": {
                    "displayName": "sucre ecuatoriano",
                    "displayName-count-one": "sucre ecuatoriano",
                    "displayName-count-other": "sucres ecuatorianos",
                    "symbol": "ECS"
                },
                "ECV": {
                    "displayName": "unidad de valor constante (UVC) ecuatoriana",
                    "displayName-count-one": "unidad de valor constante (UVC) ecuatoriana",
                    "displayName-count-other": "unidades de valor constante (UVC) ecuatorianas",
                    "symbol": "ECV"
                },
                "EEK": {
                    "displayName": "corona estonia",
                    "displayName-count-one": "corona estonia",
                    "displayName-count-other": "coronas estonias",
                    "symbol": "EEK"
                },
                "EGP": {
                    "displayName": "libra egipcia",
                    "displayName-count-one": "libra egipcia",
                    "displayName-count-other": "libras egipcias",
                    "symbol": "EGP",
                    "symbol-alt-narrow": "EGP"
                },
                "ERN": {
                    "displayName": "nakfa",
                    "displayName-count-one": "nakfa",
                    "displayName-count-other": "nakfas",
                    "symbol": "ERN"
                },
                "ESA": {
                    "displayName": "peseta española (cuenta A)",
                    "displayName-count-one": "peseta española (cuenta A)",
                    "displayName-count-other": "pesetas españolas (cuenta A)",
                    "symbol": "ESA"
                },
                "ESB": {
                    "displayName": "peseta española (cuenta convertible)",
                    "displayName-count-one": "peseta española (cuenta convertible)",
                    "displayName-count-other": "pesetas españolas (cuenta convertible)",
                    "symbol": "ESB"
                },
                "ESP": {
                    "displayName": "peseta española",
                    "displayName-count-one": "peseta española",
                    "displayName-count-other": "pesetas españolas",
                    "symbol": "₧",
                    "symbol-alt-narrow": "₧"
                },
                "ETB": {
                    "displayName": "bir",
                    "displayName-count-one": "bir",
                    "displayName-count-other": "bires",
                    "symbol": "ETB"
                },
                "EUR": {
                    "displayName": "euro",
                    "displayName-count-one": "euro",
                    "displayName-count-other": "euros",
                    "symbol": "€",
                    "symbol-alt-narrow": "€"
                },
                "FIM": {
                    "displayName": "marco finlandés",
                    "displayName-count-one": "marco finlandés",
                    "displayName-count-other": "marcos finlandeses",
                    "symbol": "FIM"
                },
                "FJD": {
                    "displayName": "dólar fiyiano",
                    "displayName-count-one": "dólar fiyiano",
                    "displayName-count-other": "dólares fiyianos",
                    "symbol": "FJD",
                    "symbol-alt-narrow": "$"
                },
                "FKP": {
                    "displayName": "libra malvinense",
                    "displayName-count-one": "libra malvinense",
                    "displayName-count-other": "libras malvinenses",
                    "symbol": "FKP",
                    "symbol-alt-narrow": "£"
                },
                "FRF": {
                    "displayName": "franco francés",
                    "displayName-count-one": "franco francés",
                    "displayName-count-other": "francos franceses",
                    "symbol": "FRF"
                },
                "GBP": {
                    "displayName": "libra británica",
                    "displayName-count-one": "libra británica",
                    "displayName-count-other": "libras británicas",
                    "symbol": "GBP",
                    "symbol-alt-narrow": "£"
                },
                "GEK": {
                    "displayName": "kupon larit georgiano",
                    "symbol": "GEK"
                },
                "GEL": {
                    "displayName": "lari",
                    "displayName-count-one": "lari",
                    "displayName-count-other": "laris",
                    "symbol": "GEL",
                    "symbol-alt-narrow": "₾",
                    "symbol-alt-variant": "₾"
                },
                "GHC": {
                    "displayName": "cedi ghanés (1979–2007)",
                    "symbol": "GHC"
                },
                "GHS": {
                    "displayName": "cedi",
                    "displayName-count-one": "cedi",
                    "displayName-count-other": "cedis",
                    "symbol": "GHS"
                },
                "GIP": {
                    "displayName": "libra gibraltareña",
                    "displayName-count-one": "libra gibraltareña",
                    "displayName-count-other": "libras gibraltareñas",
                    "symbol": "GIP",
                    "symbol-alt-narrow": "£"
                },
                "GMD": {
                    "displayName": "dalasi",
                    "displayName-count-one": "dalasi",
                    "displayName-count-other": "dalasis",
                    "symbol": "GMD"
                },
                "GNF": {
                    "displayName": "franco guineano",
                    "displayName-count-one": "franco guineano",
                    "displayName-count-other": "francos guineanos",
                    "symbol": "GNF",
                    "symbol-alt-narrow": "FG"
                },
                "GNS": {
                    "displayName": "syli guineano",
                    "symbol": "GNS"
                },
                "GQE": {
                    "displayName": "ekuele de Guinea Ecuatorial",
                    "displayName-count-one": "ekuele de Guinea Ecuatorial",
                    "displayName-count-other": "ekueles de Guinea Ecuatorial",
                    "symbol": "GQE"
                },
                "GRD": {
                    "displayName": "dracma griego",
                    "displayName-count-one": "dracma griego",
                    "displayName-count-other": "dracmas griegos",
                    "symbol": "GRD"
                },
                "GTQ": {
                    "displayName": "quetzal guatemalteco",
                    "displayName-count-one": "quetzal guatemalteco",
                    "displayName-count-other": "quetzales guatemaltecos",
                    "symbol": "GTQ",
                    "symbol-alt-narrow": "Q"
                },
                "GWE": {
                    "displayName": "escudo de Guinea Portuguesa",
                    "symbol": "GWE"
                },
                "GWP": {
                    "displayName": "peso de Guinea-Bissáu",
                    "symbol": "GWP"
                },
                "GYD": {
                    "displayName": "dólar guyanés",
                    "displayName-count-one": "dólar guyanés",
                    "displayName-count-other": "dólares guyaneses",
                    "symbol": "GYD",
                    "symbol-alt-narrow": "$"
                },
                "HKD": {
                    "displayName": "dólar hongkonés",
                    "displayName-count-one": "dólar hongkonés",
                    "displayName-count-other": "dólares hongkoneses",
                    "symbol": "HKD",
                    "symbol-alt-narrow": "$"
                },
                "HNL": {
                    "displayName": "lempira hondureño",
                    "displayName-count-one": "lempira hondureño",
                    "displayName-count-other": "lempiras hondureños",
                    "symbol": "HNL",
                    "symbol-alt-narrow": "L"
                },
                "HRD": {
                    "displayName": "dinar croata",
                    "displayName-count-one": "dinar croata",
                    "displayName-count-other": "dinares croatas",
                    "symbol": "HRD"
                },
                "HRK": {
                    "displayName": "kuna",
                    "displayName-count-one": "kuna",
                    "displayName-count-other": "kunas",
                    "symbol": "HRK",
                    "symbol-alt-narrow": "kn"
                },
                "HTG": {
                    "displayName": "gourde haitiano",
                    "displayName-count-one": "gourde haitiano",
                    "displayName-count-other": "gourdes haitianos",
                    "symbol": "HTG"
                },
                "HUF": {
                    "displayName": "forinto húngaro",
                    "displayName-count-one": "forinto húngaro",
                    "displayName-count-other": "forintos húngaros",
                    "symbol": "HUF",
                    "symbol-alt-narrow": "Ft"
                },
                "IDR": {
                    "displayName": "rupia indonesia",
                    "displayName-count-one": "rupia indonesia",
                    "displayName-count-other": "rupias indonesias",
                    "symbol": "IDR",
                    "symbol-alt-narrow": "Rp"
                },
                "IEP": {
                    "displayName": "libra irlandesa",
                    "displayName-count-one": "libra irlandesa",
                    "displayName-count-other": "libras irlandesas",
                    "symbol": "IEP"
                },
                "ILP": {
                    "displayName": "libra israelí",
                    "displayName-count-one": "libra israelí",
                    "displayName-count-other": "libras israelíes",
                    "symbol": "ILP"
                },
                "ILS": {
                    "displayName": "nuevo séquel israelí",
                    "displayName-count-one": "nuevo séquel israelí",
                    "displayName-count-other": "nuevos séqueles israelíes",
                    "symbol": "ILS",
                    "symbol-alt-narrow": "₪"
                },
                "INR": {
                    "displayName": "rupia india",
                    "displayName-count-one": "rupia india",
                    "displayName-count-other": "rupias indias",
                    "symbol": "INR",
                    "symbol-alt-narrow": "₹"
                },
                "IQD": {
                    "displayName": "dinar iraquí",
                    "displayName-count-one": "dinar iraquí",
                    "displayName-count-other": "dinares iraquíes",
                    "symbol": "IQD"
                },
                "IRR": {
                    "displayName": "rial iraní",
                    "displayName-count-one": "rial iraní",
                    "displayName-count-other": "riales iraníes",
                    "symbol": "IRR"
                },
                "ISK": {
                    "displayName": "corona islandesa",
                    "displayName-count-one": "corona islandesa",
                    "displayName-count-other": "coronas islandesas",
                    "symbol": "ISK",
                    "symbol-alt-narrow": "kr"
                },
                "ITL": {
                    "displayName": "lira italiana",
                    "displayName-count-one": "lira italiana",
                    "displayName-count-other": "liras italianas",
                    "symbol": "ITL"
                },
                "JMD": {
                    "displayName": "dólar jamaicano",
                    "displayName-count-one": "dólar jamaicano",
                    "displayName-count-other": "dólares jamaicanos",
                    "symbol": "JMD",
                    "symbol-alt-narrow": "$"
                },
                "JOD": {
                    "displayName": "dinar jordano",
                    "displayName-count-one": "dinar jordano",
                    "displayName-count-other": "dinares jordanos",
                    "symbol": "JOD"
                },
                "JPY": {
                    "displayName": "yen",
                    "displayName-count-one": "yen",
                    "displayName-count-other": "yenes",
                    "symbol": "JPY",
                    "symbol-alt-narrow": "¥"
                },
                "KES": {
                    "displayName": "chelín keniano",
                    "displayName-count-one": "chelín keniano",
                    "displayName-count-other": "chelines kenianos",
                    "symbol": "KES"
                },
                "KGS": {
                    "displayName": "som",
                    "displayName-count-one": "som",
                    "displayName-count-other": "soms",
                    "symbol": "KGS"
                },
                "KHR": {
                    "displayName": "riel",
                    "displayName-count-one": "riel",
                    "displayName-count-other": "rieles",
                    "symbol": "KHR",
                    "symbol-alt-narrow": "៛"
                },
                "KMF": {
                    "displayName": "franco comorense",
                    "displayName-count-one": "franco comorense",
                    "displayName-count-other": "francos comorenses",
                    "symbol": "KMF",
                    "symbol-alt-narrow": "CF"
                },
                "KPW": {
                    "displayName": "won norcoreano",
                    "displayName-count-one": "won norcoreano",
                    "displayName-count-other": "wons norcoreanos",
                    "symbol": "KPW",
                    "symbol-alt-narrow": "₩"
                },
                "KRH": {
                    "displayName": "KRH",
                    "symbol": "KRH"
                },
                "KRO": {
                    "displayName": "KRO",
                    "symbol": "KRO"
                },
                "KRW": {
                    "displayName": "won surcoreano",
                    "displayName-count-one": "won surcoreano",
                    "displayName-count-other": "wons surcoreanos",
                    "symbol": "KRW",
                    "symbol-alt-narrow": "₩"
                },
                "KWD": {
                    "displayName": "dinar kuwaití",
                    "displayName-count-one": "dinar kuwaití",
                    "displayName-count-other": "dinares kuwaitíes",
                    "symbol": "KWD"
                },
                "KYD": {
                    "displayName": "dólar de las Islas Caimán",
                    "displayName-count-one": "dólar de las Islas Caimán",
                    "displayName-count-other": "dólares de las Islas Caimán",
                    "symbol": "KYD",
                    "symbol-alt-narrow": "$"
                },
                "KZT": {
                    "displayName": "tenge kazako",
                    "displayName-count-one": "tenge kazako",
                    "displayName-count-other": "tenges kazakos",
                    "symbol": "KZT",
                    "symbol-alt-narrow": "₸"
                },
                "LAK": {
                    "displayName": "kip",
                    "displayName-count-one": "kip",
                    "displayName-count-other": "kips",
                    "symbol": "LAK",
                    "symbol-alt-narrow": "₭"
                },
                "LBP": {
                    "displayName": "libra libanesa",
                    "displayName-count-one": "libra libanesa",
                    "displayName-count-other": "libras libanesas",
                    "symbol": "LBP",
                    "symbol-alt-narrow": "L£"
                },
                "LKR": {
                    "displayName": "rupia esrilanquesa",
                    "displayName-count-one": "rupia esrilanquesa",
                    "displayName-count-other": "rupias esrilanquesas",
                    "symbol": "LKR",
                    "symbol-alt-narrow": "Rs"
                },
                "LRD": {
                    "displayName": "dólar liberiano",
                    "displayName-count-one": "dólar liberiano",
                    "displayName-count-other": "dólares liberianos",
                    "symbol": "LRD",
                    "symbol-alt-narrow": "$"
                },
                "LSL": {
                    "displayName": "loti lesothense",
                    "symbol": "LSL"
                },
                "LTL": {
                    "displayName": "litas lituano",
                    "displayName-count-one": "litas lituana",
                    "displayName-count-other": "litas lituanas",
                    "symbol": "LTL",
                    "symbol-alt-narrow": "Lt"
                },
                "LTT": {
                    "displayName": "talonas lituano",
                    "displayName-count-one": "talonas lituana",
                    "displayName-count-other": "talonas lituanas",
                    "symbol": "LTT"
                },
                "LUC": {
                    "displayName": "franco convertible luxemburgués",
                    "displayName-count-one": "franco convertible luxemburgués",
                    "displayName-count-other": "francos convertibles luxemburgueses",
                    "symbol": "LUC"
                },
                "LUF": {
                    "displayName": "franco luxemburgués",
                    "displayName-count-one": "franco luxemburgués",
                    "displayName-count-other": "francos luxemburgueses",
                    "symbol": "LUF"
                },
                "LUL": {
                    "displayName": "franco financiero luxemburgués",
                    "displayName-count-one": "franco financiero luxemburgués",
                    "displayName-count-other": "francos financieros luxemburgueses",
                    "symbol": "LUL"
                },
                "LVL": {
                    "displayName": "lats letón",
                    "displayName-count-one": "lats letón",
                    "displayName-count-other": "lats letónes",
                    "symbol": "LVL",
                    "symbol-alt-narrow": "Ls"
                },
                "LVR": {
                    "displayName": "rublo letón",
                    "displayName-count-one": "rublo letón",
                    "displayName-count-other": "rublos letones",
                    "symbol": "LVR"
                },
                "LYD": {
                    "displayName": "dinar libio",
                    "displayName-count-one": "dinar libio",
                    "displayName-count-other": "dinares libios",
                    "symbol": "LYD"
                },
                "MAD": {
                    "displayName": "dírham marroquí",
                    "displayName-count-one": "dírham marroquí",
                    "displayName-count-other": "dírhams marroquíes",
                    "symbol": "MAD"
                },
                "MAF": {
                    "displayName": "franco marroquí",
                    "displayName-count-one": "franco marroquí",
                    "displayName-count-other": "francos marroquíes",
                    "symbol": "MAF"
                },
                "MCF": {
                    "displayName": "MCF",
                    "symbol": "MCF"
                },
                "MDC": {
                    "displayName": "MDC",
                    "symbol": "MDC"
                },
                "MDL": {
                    "displayName": "leu moldavo",
                    "displayName-count-one": "leu moldavo",
                    "displayName-count-other": "leus moldavos",
                    "symbol": "MDL"
                },
                "MGA": {
                    "displayName": "ariari",
                    "displayName-count-one": "ariari",
                    "displayName-count-other": "ariaris",
                    "symbol": "MGA",
                    "symbol-alt-narrow": "Ar"
                },
                "MGF": {
                    "displayName": "franco malgache",
                    "symbol": "MGF"
                },
                "MKD": {
                    "displayName": "dinar macedonio",
                    "displayName-count-one": "dinar macedonio",
                    "displayName-count-other": "dinares macedonios",
                    "symbol": "MKD"
                },
                "MKN": {
                    "displayName": "MKN",
                    "symbol": "MKN"
                },
                "MLF": {
                    "displayName": "franco malí",
                    "symbol": "MLF"
                },
                "MMK": {
                    "displayName": "kiat",
                    "displayName-count-one": "kiat",
                    "displayName-count-other": "kiats",
                    "symbol": "MMK",
                    "symbol-alt-narrow": "K"
                },
                "MNT": {
                    "displayName": "tugrik",
                    "displayName-count-one": "tugrik",
                    "displayName-count-other": "tugriks",
                    "symbol": "MNT",
                    "symbol-alt-narrow": "₮"
                },
                "MOP": {
                    "displayName": "pataca de Macao",
                    "displayName-count-one": "pataca de Macao",
                    "displayName-count-other": "patacas de Macao",
                    "symbol": "MOP"
                },
                "MRO": {
                    "displayName": "uguiya",
                    "displayName-count-one": "uguiya",
                    "displayName-count-other": "uguiyas",
                    "symbol": "MRO"
                },
                "MTL": {
                    "displayName": "lira maltesa",
                    "displayName-count-one": "lira maltesa",
                    "displayName-count-other": "liras maltesas",
                    "symbol": "MTL"
                },
                "MTP": {
                    "displayName": "libra maltesa",
                    "displayName-count-one": "libra maltesa",
                    "displayName-count-other": "libras maltesas",
                    "symbol": "MTP"
                },
                "MUR": {
                    "displayName": "rupia mauriciana",
                    "displayName-count-one": "rupia mauriciana",
                    "displayName-count-other": "rupias mauricianas",
                    "symbol": "MUR",
                    "symbol-alt-narrow": "Rs"
                },
                "MVR": {
                    "displayName": "rufiya",
                    "displayName-count-one": "rufiya",
                    "displayName-count-other": "rufiyas",
                    "symbol": "MVR"
                },
                "MWK": {
                    "displayName": "kwacha malauí",
                    "displayName-count-one": "kwacha malauí",
                    "displayName-count-other": "kwachas malauís",
                    "symbol": "MWK"
                },
                "MXN": {
                    "displayName": "peso mexicano",
                    "displayName-count-one": "peso mexicano",
                    "displayName-count-other": "pesos mexicanos",
                    "symbol": "MXN",
                    "symbol-alt-narrow": "$"
                },
                "MXP": {
                    "displayName": "peso de plata mexicano (1861–1992)",
                    "displayName-count-one": "peso de plata mexicano (MXP)",
                    "displayName-count-other": "pesos de plata mexicanos (MXP)",
                    "symbol": "MXP"
                },
                "MXV": {
                    "displayName": "unidad de inversión (UDI) mexicana",
                    "displayName-count-one": "unidad de inversión (UDI) mexicana",
                    "displayName-count-other": "unidades de inversión (UDI) mexicanas",
                    "symbol": "MXV"
                },
                "MYR": {
                    "displayName": "ringit",
                    "displayName-count-one": "ringit",
                    "displayName-count-other": "ringits",
                    "symbol": "MYR",
                    "symbol-alt-narrow": "RM"
                },
                "MZE": {
                    "displayName": "escudo mozambiqueño",
                    "displayName-count-one": "escudo mozambiqueño",
                    "displayName-count-other": "escudos mozambiqueños",
                    "symbol": "MZE"
                },
                "MZM": {
                    "displayName": "antiguo metical mozambiqueño",
                    "symbol": "MZM"
                },
                "MZN": {
                    "displayName": "metical",
                    "displayName-count-one": "metical",
                    "displayName-count-other": "meticales",
                    "symbol": "MZN"
                },
                "NAD": {
                    "displayName": "dólar namibio",
                    "displayName-count-one": "dólar namibio",
                    "displayName-count-other": "dólares namibios",
                    "symbol": "NAD",
                    "symbol-alt-narrow": "$"
                },
                "NGN": {
                    "displayName": "naira",
                    "displayName-count-one": "naira",
                    "displayName-count-other": "nairas",
                    "symbol": "NGN",
                    "symbol-alt-narrow": "₦"
                },
                "NIC": {
                    "displayName": "córdoba nicaragüense (1988–1991)",
                    "displayName-count-one": "córdoba nicaragüense (1988–1991)",
                    "displayName-count-other": "córdobas nicaragüenses (1988–1991)",
                    "symbol": "NIC"
                },
                "NIO": {
                    "displayName": "córdoba nicaragüense",
                    "displayName-count-one": "córdoba nicaragüense",
                    "displayName-count-other": "córdobas nicaragüenses",
                    "symbol": "NIO",
                    "symbol-alt-narrow": "C$"
                },
                "NLG": {
                    "displayName": "florín neerlandés",
                    "displayName-count-one": "florín neerlandés",
                    "displayName-count-other": "florines neerlandeses",
                    "symbol": "NLG"
                },
                "NOK": {
                    "displayName": "corona noruega",
                    "displayName-count-one": "corona noruega",
                    "displayName-count-other": "coronas noruegas",
                    "symbol": "NOK",
                    "symbol-alt-narrow": "kr"
                },
                "NPR": {
                    "displayName": "rupia nepalí",
                    "displayName-count-one": "rupia nepalí",
                    "displayName-count-other": "rupias nepalíes",
                    "symbol": "NPR",
                    "symbol-alt-narrow": "Rs"
                },
                "NZD": {
                    "displayName": "dólar neozelandés",
                    "displayName-count-one": "dólar neozelandés",
                    "displayName-count-other": "dólares neozelandeses",
                    "symbol": "NZD",
                    "symbol-alt-narrow": "$"
                },
                "OMR": {
                    "displayName": "rial omaní",
                    "displayName-count-one": "rial omaní",
                    "displayName-count-other": "riales omaníes",
                    "symbol": "OMR"
                },
                "PAB": {
                    "displayName": "balboa panameño",
                    "displayName-count-one": "balboa panameño",
                    "displayName-count-other": "balboas panameños",
                    "symbol": "PAB"
                },
                "PEI": {
                    "displayName": "inti peruano",
                    "displayName-count-one": "inti peruano",
                    "displayName-count-other": "intis peruanos",
                    "symbol": "PEI"
                },
                "PEN": {
                    "displayName": "nuevo sol peruano",
                    "displayName-count-one": "nuevo sol peruano",
                    "displayName-count-other": "nuevos soles peruanos",
                    "symbol": "PEN"
                },
                "PES": {
                    "displayName": "sol peruano",
                    "displayName-count-one": "sol peruano",
                    "displayName-count-other": "soles peruanos",
                    "symbol": "PES"
                },
                "PGK": {
                    "displayName": "kina",
                    "displayName-count-one": "kina",
                    "displayName-count-other": "kinas",
                    "symbol": "PGK"
                },
                "PHP": {
                    "displayName": "peso filipino",
                    "displayName-count-one": "peso filipino",
                    "displayName-count-other": "pesos filipinos",
                    "symbol": "PHP",
                    "symbol-alt-narrow": "₱"
                },
                "PKR": {
                    "displayName": "rupia pakistaní",
                    "displayName-count-one": "rupia pakistaní",
                    "displayName-count-other": "rupias pakistaníes",
                    "symbol": "PKR",
                    "symbol-alt-narrow": "Rs"
                },
                "PLN": {
                    "displayName": "esloti",
                    "displayName-count-one": "esloti",
                    "displayName-count-other": "eslotis",
                    "symbol": "PLN",
                    "symbol-alt-narrow": "zł"
                },
                "PLZ": {
                    "displayName": "zloty polaco (1950–1995)",
                    "displayName-count-one": "zloty polaco (PLZ)",
                    "displayName-count-other": "zlotys polacos (PLZ)",
                    "symbol": "PLZ"
                },
                "PTE": {
                    "displayName": "escudo portugués",
                    "displayName-count-one": "escudo portugués",
                    "displayName-count-other": "escudos portugueses",
                    "symbol": "PTE"
                },
                "PYG": {
                    "displayName": "guaraní paraguayo",
                    "displayName-count-one": "guaraní paraguayo",
                    "displayName-count-other": "guaraníes paraguayos",
                    "symbol": "PYG",
                    "symbol-alt-narrow": "₲"
                },
                "QAR": {
                    "displayName": "rial catarí",
                    "displayName-count-one": "rial catarí",
                    "displayName-count-other": "riales cataríes",
                    "symbol": "QAR"
                },
                "RHD": {
                    "displayName": "dólar rodesiano",
                    "symbol": "RHD"
                },
                "ROL": {
                    "displayName": "antiguo leu rumano",
                    "displayName-count-one": "antiguo leu rumano",
                    "displayName-count-other": "antiguos lei rumanos",
                    "symbol": "ROL"
                },
                "RON": {
                    "displayName": "leu rumano",
                    "displayName-count-one": "leu rumano",
                    "displayName-count-other": "leus rumanos",
                    "symbol": "RON"
                },
                "RSD": {
                    "displayName": "dinar serbio",
                    "displayName-count-one": "dinar serbio",
                    "displayName-count-other": "dinares serbios",
                    "symbol": "RSD"
                },
                "RUB": {
                    "displayName": "rublo ruso",
                    "displayName-count-one": "rublo ruso",
                    "displayName-count-other": "rublos rusos",
                    "symbol": "RUB",
                    "symbol-alt-narrow": "₽"
                },
                "RUR": {
                    "displayName": "rublo ruso (1991–1998)",
                    "displayName-count-one": "rublo ruso (RUR)",
                    "displayName-count-other": "rublos rusos (RUR)",
                    "symbol": "RUR",
                    "symbol-alt-narrow": "р."
                },
                "RWF": {
                    "displayName": "franco ruandés",
                    "displayName-count-one": "franco ruandés",
                    "displayName-count-other": "francos ruandeses",
                    "symbol": "RWF",
                    "symbol-alt-narrow": "RF"
                },
                "SAR": {
                    "displayName": "rial saudí",
                    "displayName-count-one": "rial saudí",
                    "displayName-count-other": "riales saudíes",
                    "symbol": "SAR"
                },
                "SBD": {
                    "displayName": "dólar salomonense",
                    "displayName-count-one": "dólar salomonense",
                    "displayName-count-other": "dólares salomonenses",
                    "symbol": "SBD",
                    "symbol-alt-narrow": "$"
                },
                "SCR": {
                    "displayName": "rupia seychellense",
                    "displayName-count-one": "rupia seychellense",
                    "displayName-count-other": "rupias seychellenses",
                    "symbol": "SCR"
                },
                "SDD": {
                    "displayName": "dinar sudanés",
                    "displayName-count-one": "dinar sudanés",
                    "displayName-count-other": "dinares sudaneses",
                    "symbol": "SDD"
                },
                "SDG": {
                    "displayName": "libra sudanesa",
                    "displayName-count-one": "libra sudanesa",
                    "displayName-count-other": "libras sudanesas",
                    "symbol": "SDG"
                },
                "SDP": {
                    "displayName": "libra sudanesa antigua",
                    "displayName-count-one": "libra sudanesa antigua",
                    "displayName-count-other": "libras sudanesas antiguas",
                    "symbol": "SDP"
                },
                "SEK": {
                    "displayName": "corona sueca",
                    "displayName-count-one": "corona sueca",
                    "displayName-count-other": "coronas suecas",
                    "symbol": "SEK",
                    "symbol-alt-narrow": "kr"
                },
                "SGD": {
                    "displayName": "dólar singapurense",
                    "displayName-count-one": "dólar singapurense",
                    "displayName-count-other": "dólares singapurenses",
                    "symbol": "SGD",
                    "symbol-alt-narrow": "$"
                },
                "SHP": {
                    "displayName": "libra de Santa Elena",
                    "displayName-count-one": "libra de Santa Elena",
                    "displayName-count-other": "libras de Santa Elena",
                    "symbol": "SHP",
                    "symbol-alt-narrow": "£"
                },
                "SIT": {
                    "displayName": "tólar esloveno",
                    "displayName-count-one": "tólar esloveno",
                    "displayName-count-other": "tólares eslovenos",
                    "symbol": "SIT"
                },
                "SKK": {
                    "displayName": "corona eslovaca",
                    "displayName-count-one": "corona eslovaca",
                    "displayName-count-other": "coronas eslovacas",
                    "symbol": "SKK"
                },
                "SLL": {
                    "displayName": "leona",
                    "displayName-count-one": "leona",
                    "displayName-count-other": "leonas",
                    "symbol": "SLL"
                },
                "SOS": {
                    "displayName": "chelín somalí",
                    "displayName-count-one": "chelín somalí",
                    "displayName-count-other": "chelines somalíes",
                    "symbol": "SOS"
                },
                "SRD": {
                    "displayName": "dólar surinamés",
                    "displayName-count-one": "dólar surinamés",
                    "displayName-count-other": "dólares surinameses",
                    "symbol": "SRD",
                    "symbol-alt-narrow": "$"
                },
                "SRG": {
                    "displayName": "florín surinamés",
                    "symbol": "SRG"
                },
                "SSP": {
                    "displayName": "libra sursudanesa",
                    "displayName-count-one": "libra sursudanesa",
                    "displayName-count-other": "libras sursudanesas",
                    "symbol": "SSP",
                    "symbol-alt-narrow": "£"
                },
                "STD": {
                    "displayName": "dobra",
                    "displayName-count-one": "dobra",
                    "displayName-count-other": "dobras",
                    "symbol": "STD",
                    "symbol-alt-narrow": "Db"
                },
                "SUR": {
                    "displayName": "rublo soviético",
                    "displayName-count-one": "rublo soviético",
                    "displayName-count-other": "rublos soviéticos",
                    "symbol": "SUR"
                },
                "SVC": {
                    "displayName": "colón salvadoreño",
                    "displayName-count-one": "colón salvadoreño",
                    "displayName-count-other": "colones salvadoreños",
                    "symbol": "SVC"
                },
                "SYP": {
                    "displayName": "libra siria",
                    "displayName-count-one": "libra siria",
                    "displayName-count-other": "libras sirias",
                    "symbol": "SYP",
                    "symbol-alt-narrow": "£"
                },
                "SZL": {
                    "displayName": "lilangeni",
                    "displayName-count-one": "lilangeni",
                    "displayName-count-other": "lilangenis",
                    "symbol": "SZL"
                },
                "THB": {
                    "displayName": "bat",
                    "displayName-count-one": "bat",
                    "displayName-count-other": "bats",
                    "symbol": "฿",
                    "symbol-alt-narrow": "฿"
                },
                "TJR": {
                    "displayName": "rublo tayiko",
                    "symbol": "TJR"
                },
                "TJS": {
                    "displayName": "somoni tayiko",
                    "displayName-count-one": "somoni tayiko",
                    "displayName-count-other": "somonis tayikos",
                    "symbol": "TJS"
                },
                "TMM": {
                    "displayName": "manat turcomano (1993–2009)",
                    "displayName-count-one": "manat turcomano (1993–2009)",
                    "displayName-count-other": "manats turcomanos (1993–2009)",
                    "symbol": "TMM"
                },
                "TMT": {
                    "displayName": "manat turcomano",
                    "displayName-count-one": "manat turcomano",
                    "displayName-count-other": "manats turcomanos",
                    "symbol": "TMT"
                },
                "TND": {
                    "displayName": "dinar tunecino",
                    "displayName-count-one": "dinar tunecino",
                    "displayName-count-other": "dinares tunecinos",
                    "symbol": "TND"
                },
                "TOP": {
                    "displayName": "paanga",
                    "displayName-count-one": "paanga",
                    "displayName-count-other": "paangas",
                    "symbol": "TOP",
                    "symbol-alt-narrow": "T$"
                },
                "TPE": {
                    "displayName": "escudo timorense",
                    "symbol": "TPE"
                },
                "TRL": {
                    "displayName": "lira turca (1922–2005)",
                    "displayName-count-one": "lira turca (1922–2005)",
                    "displayName-count-other": "liras turcas (1922–2005)",
                    "symbol": "TRL"
                },
                "TRY": {
                    "displayName": "lira turca",
                    "displayName-count-one": "lira turca",
                    "displayName-count-other": "liras turcas",
                    "symbol": "TRY",
                    "symbol-alt-narrow": "₺",
                    "symbol-alt-variant": "TL"
                },
                "TTD": {
                    "displayName": "dólar de Trinidad y Tobago",
                    "displayName-count-one": "dólar de Trinidad y Tobago",
                    "displayName-count-other": "dólares de Trinidad y Tobago",
                    "symbol": "TTD",
                    "symbol-alt-narrow": "$"
                },
                "TWD": {
                    "displayName": "nuevo dólar taiwanés",
                    "displayName-count-one": "nuevo dólar taiwanés",
                    "displayName-count-other": "nuevos dólares taiwaneses",
                    "symbol": "TWD",
                    "symbol-alt-narrow": "NT$"
                },
                "TZS": {
                    "displayName": "chelín tanzano",
                    "displayName-count-one": "chelín tanzano",
                    "displayName-count-other": "chelines tanzanos",
                    "symbol": "TZS"
                },
                "UAH": {
                    "displayName": "grivna",
                    "displayName-count-one": "grivna",
                    "displayName-count-other": "grivnas",
                    "symbol": "UAH",
                    "symbol-alt-narrow": "₴"
                },
                "UAK": {
                    "displayName": "karbovanet ucraniano",
                    "displayName-count-one": "karbovanet ucraniano",
                    "displayName-count-other": "karbovanets ucranianos",
                    "symbol": "UAK"
                },
                "UGS": {
                    "displayName": "chelín ugandés (1966–1987)",
                    "symbol": "UGS"
                },
                "UGX": {
                    "displayName": "chelín ugandés",
                    "displayName-count-one": "chelín ugandés",
                    "displayName-count-other": "chelines ugandeses",
                    "symbol": "UGX"
                },
                "USD": {
                    "displayName": "dólar estadounidense",
                    "displayName-count-one": "dólar estadounidense",
                    "displayName-count-other": "dólares estadounidenses",
                    "symbol": "$",
                    "symbol-alt-narrow": "$"
                },
                "USN": {
                    "displayName": "dólar estadounidense (día siguiente)",
                    "displayName-count-one": "dólar estadounidense (día siguiente)",
                    "displayName-count-other": "dólares estadounidenses (día siguiente)",
                    "symbol": "USN"
                },
                "USS": {
                    "displayName": "dólar estadounidense (mismo día)",
                    "displayName-count-one": "dólar estadounidense (mismo día)",
                    "displayName-count-other": "dólares estadounidenses (mismo día)",
                    "symbol": "USS"
                },
                "UYI": {
                    "displayName": "peso uruguayo en unidades indexadas",
                    "displayName-count-one": "peso uruguayo en unidades indexadas",
                    "displayName-count-other": "pesos uruguayos en unidades indexadas",
                    "symbol": "UYI"
                },
                "UYP": {
                    "displayName": "peso uruguayo (1975–1993)",
                    "displayName-count-one": "peso uruguayo (UYP)",
                    "displayName-count-other": "pesos uruguayos (UYP)",
                    "symbol": "UYP"
                },
                "UYU": {
                    "displayName": "peso uruguayo",
                    "displayName-count-one": "peso uruguayo",
                    "displayName-count-other": "pesos uruguayos",
                    "symbol": "UYU",
                    "symbol-alt-narrow": "$"
                },
                "UZS": {
                    "displayName": "sum",
                    "displayName-count-one": "sum",
                    "displayName-count-other": "sums",
                    "symbol": "UZS"
                },
                "VEB": {
                    "displayName": "bolívar venezolano (1871–2008)",
                    "displayName-count-one": "bolívar venezolano (1871–2008)",
                    "displayName-count-other": "bolívares venezolanos (1871–2008)",
                    "symbol": "VEB"
                },
                "VEF": {
                    "displayName": "bolívar venezolano",
                    "displayName-count-one": "bolívar venezolano",
                    "displayName-count-other": "bolívares venezolanos",
                    "symbol": "VEF",
                    "symbol-alt-narrow": "Bs"
                },
                "VND": {
                    "displayName": "dong",
                    "displayName-count-one": "dong",
                    "displayName-count-other": "dongs",
                    "symbol": "₫",
                    "symbol-alt-narrow": "₫"
                },
                "VNN": {
                    "displayName": "VNN",
                    "symbol": "VNN"
                },
                "VUV": {
                    "displayName": "vatu",
                    "displayName-count-one": "vatu",
                    "displayName-count-other": "vatus",
                    "symbol": "VUV"
                },
                "WST": {
                    "displayName": "tala",
                    "displayName-count-one": "tala",
                    "displayName-count-other": "talas",
                    "symbol": "WST"
                },
                "XAF": {
                    "displayName": "franco CFA BEAC",
                    "displayName-count-one": "franco CFA BEAC",
                    "displayName-count-other": "francos CFA BEAC",
                    "symbol": "XAF"
                },
                "XAG": {
                    "displayName": "plata",
                    "displayName-count-one": "plata",
                    "displayName-count-other": "plata",
                    "symbol": "XAG"
                },
                "XAU": {
                    "displayName": "oro",
                    "displayName-count-one": "oro",
                    "displayName-count-other": "oro",
                    "symbol": "XAU"
                },
                "XBA": {
                    "displayName": "unidad compuesta europea",
                    "displayName-count-one": "unidad compuesta europea",
                    "displayName-count-other": "unidades compuestas europeas",
                    "symbol": "XBA"
                },
                "XBB": {
                    "displayName": "unidad monetaria europea",
                    "displayName-count-one": "unidad monetaria europea",
                    "displayName-count-other": "unidades monetarias europeas",
                    "symbol": "XBB"
                },
                "XBC": {
                    "displayName": "unidad de cuenta europea (XBC)",
                    "displayName-count-one": "unidad de cuenta europea (XBC)",
                    "displayName-count-other": "unidades de cuenta europeas (XBC)",
                    "symbol": "XBC"
                },
                "XBD": {
                    "displayName": "unidad de cuenta europea (XBD)",
                    "displayName-count-one": "unidad de cuenta europea (XBD)",
                    "displayName-count-other": "unidades de cuenta europeas (XBD)",
                    "symbol": "XBD"
                },
                "XCD": {
                    "displayName": "dólar del Caribe Oriental",
                    "displayName-count-one": "dólar del Caribe Oriental",
                    "displayName-count-other": "dólares del Caribe Oriental",
                    "symbol": "XCD",
                    "symbol-alt-narrow": "$"
                },
                "XDR": {
                    "displayName": "derechos especiales de giro",
                    "symbol": "XDR"
                },
                "XEU": {
                    "displayName": "unidad de moneda europea",
                    "displayName-count-one": "unidad de moneda europea",
                    "displayName-count-other": "unidades de moneda europeas",
                    "symbol": "XEU"
                },
                "XFO": {
                    "displayName": "franco oro francés",
                    "displayName-count-one": "franco oro francés",
                    "displayName-count-other": "francos oro franceses",
                    "symbol": "XFO"
                },
                "XFU": {
                    "displayName": "franco UIC francés",
                    "displayName-count-one": "franco UIC francés",
                    "displayName-count-other": "francos UIC franceses",
                    "symbol": "XFU"
                },
                "XOF": {
                    "displayName": "franco CFA BCEAO",
                    "displayName-count-one": "franco CFA BCEAO",
                    "displayName-count-other": "francos CFA BCEAO",
                    "symbol": "XOF"
                },
                "XPD": {
                    "displayName": "paladio",
                    "displayName-count-one": "paladio",
                    "displayName-count-other": "paladio",
                    "symbol": "XPD"
                },
                "XPF": {
                    "displayName": "franco CFP",
                    "displayName-count-one": "franco CFP",
                    "displayName-count-other": "francos CFP",
                    "symbol": "CFPF"
                },
                "XPT": {
                    "displayName": "platino",
                    "displayName-count-one": "platino",
                    "displayName-count-other": "platino",
                    "symbol": "XPT"
                },
                "XRE": {
                    "displayName": "fondos RINET",
                    "symbol": "XRE"
                },
                "XSU": {
                    "displayName": "XSU",
                    "symbol": "XSU"
                },
                "XTS": {
                    "displayName": "código reservado para pruebas",
                    "symbol": "XTS"
                },
                "XUA": {
                    "displayName": "XUA",
                    "symbol": "XUA"
                },
                "XXX": {
                    "displayName": "moneda desconocida",
                    "displayName-count-one": "(moneda desconocida)",
                    "displayName-count-other": "(moneda desconocida)",
                    "symbol": "XXX"
                },
                "YDD": {
                    "displayName": "dinar yemení",
                    "symbol": "YDD"
                },
                "YER": {
                    "displayName": "rial yemení",
                    "displayName-count-one": "rial yemení",
                    "displayName-count-other": "riales yemeníes",
                    "symbol": "YER"
                },
                "YUD": {
                    "displayName": "dinar fuerte yugoslavo",
                    "symbol": "YUD"
                },
                "YUM": {
                    "displayName": "super dinar yugoslavo",
                    "symbol": "YUM"
                },
                "YUN": {
                    "displayName": "dinar convertible yugoslavo",
                    "displayName-count-one": "dinar convertible yugoslavo",
                    "displayName-count-other": "dinares convertibles yugoslavos",
                    "symbol": "YUN"
                },
                "YUR": {
                    "displayName": "YUR",
                    "symbol": "YUR"
                },
                "ZAL": {
                    "displayName": "rand sudafricano (financiero)",
                    "symbol": "ZAL"
                },
                "ZAR": {
                    "displayName": "rand",
                    "displayName-count-one": "rand",
                    "displayName-count-other": "rands",
                    "symbol": "ZAR",
                    "symbol-alt-narrow": "R"
                },
                "ZMK": {
                    "displayName": "kwacha zambiano (1968–2012)",
                    "displayName-count-one": "kwacha zambiano (1968–2012)",
                    "displayName-count-other": "kwachas zambianos (1968–2012)",
                    "symbol": "ZMK"
                },
                "ZMW": {
                    "displayName": "kuacha zambiano",
                    "displayName-count-one": "kuacha zambiano",
                    "displayName-count-other": "kuachas zambianos",
                    "symbol": "ZMW",
                    "symbol-alt-narrow": "ZK"
                },
                "ZRN": {
                    "displayName": "nuevo zaire zaireño",
                    "symbol": "ZRN"
                },
                "ZRZ": {
                    "displayName": "zaire zaireño",
                    "symbol": "ZRZ"
                },
                "ZWD": {
                    "displayName": "dólar de Zimbabue",
                    "symbol": "ZWD"
                },
                "ZWL": {
                    "displayName": "dólar zimbabuense",
                    "symbol": "ZWL"
                },
                "ZWR": {
                    "displayName": "ZWR",
                    "symbol": "ZWR"
                }
                }
            }
        }
    }
},
{
    "supplemental": {
        "version": {
            "_number": "$Revision: 12447 $",
            "_unicodeVersion": "8.0.0",
            "_cldrVersion": "29"
        },
        "likelySubtags": {
            "es": "es-Latn-ES"
        },
        "plurals-type-cardinal": {
            "es": {
                "pluralRule-count-one": "n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000",
                "pluralRule-count-other": " @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"
            }
        },
        "currencyData": {
            "fractions": {
                "ADP": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "AFN": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "ALL": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "AMD": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "BHD": {
                    "_rounding": "0",
                    "_digits": "3"
                },
                "BIF": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "BYR": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "CAD": {
                    "_rounding": "0",
                    "_digits": "2",
                    "_cashRounding": "5"
                },
                "CHF": {
                    "_rounding": "0",
                    "_digits": "2",
                    "_cashRounding": "5"
                },
                "CLF": {
                    "_rounding": "0",
                    "_digits": "4"
                },
                "CLP": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "COP": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "CRC": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "CZK": {
                    "_rounding": "0",
                    "_digits": "2",
                    "_cashRounding": "0",
                    "_cashDigits": "0"
                },
                "DEFAULT": {
                    "_rounding": "0",
                    "_digits": "2"
                },
                "DJF": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "ESP": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "GNF": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "GYD": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "HUF": {
                    "_rounding": "0",
                    "_digits": "2",
                    "_cashRounding": "0",
                    "_cashDigits": "0"
                },
                "IDR": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "IQD": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "IRR": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "ISK": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "ITL": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "JOD": {
                    "_rounding": "0",
                    "_digits": "3"
                },
                "JPY": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "KMF": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "KPW": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "KRW": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "KWD": {
                    "_rounding": "0",
                    "_digits": "3"
                },
                "LAK": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "LBP": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "LUF": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "LYD": {
                    "_rounding": "0",
                    "_digits": "3"
                },
                "MGA": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "MGF": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "MMK": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "MNT": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "MRO": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "MUR": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "OMR": {
                    "_rounding": "0",
                    "_digits": "3"
                },
                "PKR": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "PYG": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "RSD": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "RWF": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "SLL": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "SOS": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "STD": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "SYP": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "TMM": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "TND": {
                    "_rounding": "0",
                    "_digits": "3"
                },
                "TRL": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "TWD": {
                    "_rounding": "0",
                    "_digits": "2",
                    "_cashRounding": "0",
                    "_cashDigits": "0"
                },
                "TZS": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "UGX": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "UYI": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "UZS": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "VND": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "VUV": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "XAF": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "XOF": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "XPF": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "YER": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "ZMK": {
                    "_rounding": "0",
                    "_digits": "0"
                },
                "ZWD": {
                    "_rounding": "0",
                    "_digits": "0"
                }
            }
        }
    }
}
];